import { render } from "./Viewer.vue?vue&type=template&id=f738e624"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"
script.render = render

export default script